export const CURRENT_SPEAKER_HCW = 'hcw';
export const CURRENT_SPEAKER_PATIENT = 'patient';